import React, { useEffect, useRef, useState } from "react";
import useWindowDimensions from "../../utils/useWindowDimensions";

interface RangeSliderCircleProps {
    onUpdate: (value: number) => void;
    default: number;
    min?: number;
    max?: number;
}

export default function RangeSliderCircle(props: RangeSliderCircleProps) {

    const [pos, setPos] = useState(0);
    const circleRef = useRef<HTMLDivElement | null>(null);

    const windowDimensions = useWindowDimensions();

    useEffect(() => {
        if(circleRef.current?.parentElement) {
            const parentWidth = circleRef.current.parentElement.offsetWidth;
            setPos(parentWidth*props.default);
        }
    }, [props.default, windowDimensions]);

    function startMoving() {
        window.addEventListener("mousemove", move);
        window.addEventListener("mouseup", stopMoving);
        window.addEventListener("selectstart", cancelSelection);
        document.body.style.pointerEvents = "none";
        circleRef.current?.classList.add("moving");
    }

    function cancelSelection(e: Event) {
        e.preventDefault();

    }

    function move(event: MouseEvent) {
        if(circleRef.current && circleRef.current.parentElement) {
            const halfCircleWidth = circleRef.current.offsetWidth/2;
            const parentWidth = circleRef.current.parentElement.offsetWidth;
            const newPos = event.clientX - circleRef.current.parentElement.offsetLeft;
            if(newPos < 0) return;
            if(newPos > parentWidth) return;
            setPos(newPos - halfCircleWidth);
            props.onUpdate(newPos / parentWidth);
        }
    }

    function stopMoving() {
        window.removeEventListener("mousemove", move);
        window.removeEventListener("mouseup", stopMoving);
        window.removeEventListener("selectstart", cancelSelection);
        document.body.style.pointerEvents = "";
        circleRef.current?.classList.remove("moving");
    }

    return <div ref={circleRef} style={{
        marginLeft: pos + "px"
    }} className="circle" onMouseDown={startMoving}/>;
}